import _ from "lodash";

export const getSystemSelectOptions = _.memoize((selectionsCount: number, bankersCount = 0) => {
    const numbers = bankersCount ? _.range(bankersCount - 1, selectionsCount - 2) : _.range(selectionsCount - 2);
    
    return numbers.map(item => {
        const value = item + 2;

        return {
            name: `${value}/${selectionsCount}`,
            value,
        };
    })
}, (...args: number[]) => args.join('_'));